import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService,ConfirmationService } from 'primeng/api';
import { ProductSizeService } from './product-size.service';

@Component({
  selector: 'app-product-size',
  templateUrl: './product-size.component.html',
  styleUrls: ['./product-size.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class ProductSizeComponent implements OnInit {
  listproductSize: any = []
  productSizeCount = 0;
  count: Number = 0
  exceptionReport: any[] = []
  model = { url: undefined, sheetName: undefined };
  submitted = false;
  load = false;
  allchecked: any
  checkedItems: any = []
  AlertsModal = false;
  newMethodModal = false;

  constructor(
    private currencyService: ProductSizeService,
    private formBuilder: FormBuilder, private messageService: MessageService, private translate: TranslateService,private confirmationService: ConfirmationService) { }


  ngOnInit(): void {
    this.loadproductSize()
  }

  onSubmit() { this.submitted = true; }


  newProductSize() {

    console.log(this.model)

    this.currencyService.addNewproductSize(this.model).subscribe(data => {
      let addNewResult: any = data
      this.exceptionReport = addNewResult.msg
      this.count = addNewResult.count
      this.AlertsModal = true;
      this.newMethodModal = false;

    }, () => { this.loadproductSize() })
  }


  checkall() {
    this.checkedItems = [];
    for (let i of this.listproductSize) {
      this.checkItem(i)
    }
    this.allchecked = true;
  }

  checkItem(item) {
    console.log("checkItem", item.checked)
    if (item.checked == undefined) {
      item.checked = true;
      console.log("checked Item", item.checked)
    } else {
      item.checked = !item.checked;
    }

    if (item.checked) {
      console.log("item checked", item.checked)
      this.checkedItems.push(item);
    } else {
      this.checkedItems.splice(this.checkedItems.indexOf(item), 1);
    }

  }

  removeCurrencys() {
    let nbrDeletedRules = 0;
    var requests = this.checkedItems.length;

    this.confirmationService.confirm({
      message: 'Are you sure you want to delete the Package?',
      header: '',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        for (let item of this.checkedItems) {
          this.currencyService.removeProductSize(item.id).subscribe(data => {
            if (data) {
              nbrDeletedRules++;
              requests--;
            }

            if (requests == 0) {
              this.messageService.add({ severity: 'success', summary: this.translate.instant('toast.success'), detail: nbrDeletedRules + nbrDeletedRules + " Currency(s) has been deleted", life: 3000 });
              this.loadproductSize();
            }
          },
            (err) => {
              //connection error
              console.log(err)
              this.messageService.add({ severity: 'error', summary: this.translate.instant('toast.missinginformation'), detail: "Please contact the Support team", life: 3000 });

            }, () => { this.checkedItems.splice(this.checkedItems.indexOf(item), 1) });
        }
      },
      reject: () => {
      }
    });

  }

  loadproductSize() {
    this.load = true;
    this.currencyService.getListProductSize().subscribe(data => {
      console.log(data)
      this.listproductSize = data
      this.productSizeCount =  this.listproductSize.length;

    }, () => { this.load = false }, () => { this.load = false })
  }

  reloadproductSize(params) {
    if (this.productSizeCount == 0) {
      this.loadproductSize();
    }
  }

  openNewModal() {
    this.newMethodModal = true;
  }


}
